import { createFileRoute } from "@tanstack/react-router";
import { CityServiceCostPage, buildCityServiceCostHead } from "@/components/CityServiceCostPage";
import { SpringsCoverageMap } from "@/components/SpringsCoverageMap";

export const Route = createFileRoute("/colorado-springs-seo-cost")({
  headers: () => ({
    "Cache-Control": "public, max-age=0, s-maxage=604800, stale-while-revalidate=2592000",
    "CDN-Cache-Control": "public, s-maxage=604800, stale-while-revalidate=2592000",
  }),
  head: () => buildCityServiceCostHead("colorado-springs", "seo"),
  component: () => (
    <>
      <CityServiceCostPage city="colorado-springs" service="seo" />
      <SpringsCoverageMap />
    </>
  ),
});
